import React from 'react';
import Create from '../../../containers/rest/Create';
import Form from '../components/Form';

const ServiceTypesCreate = props => (
  <Create {...props} resource="serviceTypes">
    <Form />
  </Create>
);

ServiceTypesCreate.propTypes = {};

export default ServiceTypesCreate;
